module.exports = __webpack_public_path__ + "img/27.22c716a.jpg";